import { ApiHealthCheck } from '@/components/ApiHealthCheck'
import { Toaster } from '@/components/ui/sonner'
import { ClearBusinessStoreDataOnLogout } from '@/hooks/useCurrentActiveBusiness'
import * as TanstackQuery from '@/integrations/tanstack-query/root-provider'
import { authClient } from '@/lib/auth/client'
import { queryClient } from '@/lib/query'
import { TanstackDevtools } from '@tanstack/react-devtools'
import type { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { Fragment } from 'react'

interface MyRouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  shellComponent: RootDocument,

  component: () => (
    <ApiHealthCheck>
      <Outlet />
      {import.meta.env.DEV && (
        <TanstackDevtools
          config={{
            position: 'bottom-left',
          }}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            {
              name: 'Tanstack Query',
              render: <ReactQueryDevtoolsPanel />,
            },
          ]}
        />
      )}
    </ApiHealthCheck>
  ),
})

function RootDocument({ children }: { children: React.ReactNode }) {
  const { data: session } = authClient.useSession() // Refresh the body when the auth session changes

  return (
    <Fragment key={session?.user.id}>
      <TanstackQuery.Provider queryClient={queryClient}>
        <ClearBusinessStoreDataOnLogout />
        {children}
      </TanstackQuery.Provider>
      <Toaster position="top-center" />
    </Fragment>
  )
}
